import React from "react";
import { DatePicker, Divider, Form, Input, Select } from "antd";
import PhoneNumberMask from "../../../../../common/inputs/AuthorizationInputs";
import PhotoUpload from "../../../../../common/components/UploadPhoto/UploadPhoto";
import moment from "moment";
import {
  DELETE_COMPANY_PHOTO,
  UPLOAD_COMPANY_PHOTO
} from "../../../api/constants";

const DateFormat = "DD.MM.YYYY";
const siteRegexp = new RegExp(
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/
);

const TaxSystem = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="offer-card__item double-margin">
      <span className="label">Система налогообложения:</span>
      <Form.Item>
        {getFieldDecorator("taxSystem")(
          <Select
            disabled={disabled}
            style={{ width: 224 }}
            placeholder="Выберите с или без НДС"
            getPopupContainer={trigger => trigger.parentNode}
          >
            <Select.Option value={0}>Без НДС</Select.Option>
            <Select.Option value={1}>С НДС</Select.Option>
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

export const CompanyInfo = ({ form, disabled }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const subjectKey = getFieldValue("subjectKey");
  const companyId = getFieldValue("companyId");
  const avatar = getFieldValue("picture");
  const eio = getFieldValue("eio");

  return (
    <>
      <div className="avatar-uploader">
        <PhotoUpload
          data={{ company_id: companyId }}
          disabled={disabled}
          image_url={avatar}
          action={UPLOAD_COMPANY_PHOTO}
          deleteAction={DELETE_COMPANY_PHOTO}
        />
      </div>
      {subjectKey && (
        <>
          {subjectKey === "physical" ? (
            <>
              <div className="offer-card__item">
                <span className="label">Фамилия:</span>
                <Form.Item>
                  {getFieldDecorator("lastname")(
                    <Input
                      disabled={disabled}
                      style={{ width: 368 }}
                      placeholder="Укажите фамилию"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="offer-card__item">
                <span className="label">Имя:</span>
                <Form.Item>
                  {getFieldDecorator("name")(
                    <Input
                      disabled={disabled}
                      style={{ width: 368 }}
                      placeholder="Укажите имя"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="offer-card__item">
                <span className="label">Отчество:</span>
                <Form.Item>
                  {getFieldDecorator("patronymic")(
                    <Input
                      style={{ width: 368 }}
                      disabled={disabled}
                      placeholder="Укажите отчество"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="offer-card__item">
                <span className="label">Дата создания:</span>
                {getFieldDecorator("createdAtDate")(
                  <DatePicker
                    style={{ width: 368 }}
                    format={DateFormat}
                    placeholder="Дата создания"
                    disabled={true}
                  />
                )}
              </div>
              <div className="offer-card__item double-margin">
                <span className="label">Дата рождения:</span>
                <Form.Item>
                  {getFieldDecorator("birthDate")(
                    <DatePicker
                      style={{ width: 224 }}
                      defaultPickerValue={moment().subtract(18, "years")}
                      format={DateFormat}
                      placeholder="Укажите дату рождения"
                      disabled={disabled}
                      disabledDate={d => {
                        return !moment()
                          .subtract(18, "years")
                          .isAfter(d);
                      }}
                    />
                  )}
                </Form.Item>
                <span
                  className="label"
                  style={{
                    width: "auto",
                    paddingLeft: 16
                  }}
                >
                  {getFieldValue("birthDate") &&
                    moment(getFieldValue("birthDate")).fromNow(true)}
                </span>
              </div>
              <div className="offer-card__item">
                <span className="label">Место рождения:</span>
                {getFieldDecorator("birthPlace")(
                  <Input
                    style={{ width: 368 }}
                    disabled={disabled}
                    placeholder="Место рождения"
                  />
                )}
              </div>
            </>
          ) : (
            <>
              <div className="offer-card__item">
                <span className="label">Наименование:</span>
                <Form.Item>
                  {getFieldDecorator("nameLegal", {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <Input
                      style={{ width: 368 }}
                      placeholder="Наименование компании"
                      disabled
                    />
                  )}
                </Form.Item>
              </div>

              <div className="offer-card__item">
                <span className="label">Юридический адрес:</span>
                <Form.Item>
                  {getFieldDecorator("addressLegal", {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <Input
                      style={{ width: 368 }}
                      placeholder="Юридический адрес"
                      disabled={true}
                    />
                  )}
                </Form.Item>
              </div>
              <div className="offer-card__item">
                <span className="label">ИНН:</span>
                <Form.Item>
                  {getFieldDecorator("inn", {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <Input
                      style={{ width: 368 }}
                      placeholder="ИНН"
                      disabled={true}
                    />
                  )}
                </Form.Item>
              </div>
              {subjectKey !== "individ" ? (
                <div className="offer-card__item">
                  <span className="label">КПП:</span>
                  <Form.Item>
                    {getFieldDecorator("kpp", {
                      rules: [
                        {
                          required: true,
                          message: "Поле, обязательное для заполнения"
                        }
                      ]
                    })(
                      <Input
                        style={{ width: 368 }}
                        placeholder="КПП"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                </div>
              ) : null}

              <div className="offer-card__item">
                <span className="label">
                  {subjectKey === "individ" ? "ОГРНИП" : "ОГРН"}:
                </span>
                <Form.Item>
                  {getFieldDecorator("ogrn", {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <Input style={{ width: 368 }} placeholder="ОГРН" disabled />
                  )}
                </Form.Item>
              </div>
              {subjectKey !== "individ" && !!eio ? (
                <div className="offer-card__item">
                  <span className="label">ЕИО:</span>
                  <Form.Item>
                    {getFieldDecorator("eio")(
                      <Input
                        style={{ width: 368 }}
                        placeholder="Не указано"
                        disabled
                      />
                    )}
                  </Form.Item>
                </div>
              ) : null}
              <TaxSystem form={form} disabled={disabled} />
              <div className="offer-card__item double-margin">
                <span className="label">Фактический адрес:</span>
                <Form.Item>
                  {getFieldDecorator("addressFact")(
                    <Input
                      style={{ width: 368 }}
                      placeholder="Не указано"
                      disabled={disabled}
                    />
                  )}
                </Form.Item>
              </div>
              <div className="offer-card__item">
                <span className="label">ID в АЦБПДП:</span>
                <Form.Item>
                  {getFieldDecorator("cashierAccount")(
                    <Input
                      style={{ width: 368 }}
                      placeholder="Не указано"
                      disabled={disabled}
                    />
                  )}
                </Form.Item>
              </div>
            </>
          )}
        </>
      )}
      <Divider />
      <div className="offer-card__item double-margin">
        <span className="label">Номер телефона компании:</span>
        <Form.Item>
          {getFieldDecorator("phoneCode")(
            <Input style={{ width: 80 }} disabled={disabled} />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("phone")(
            <PhoneNumberMask
              autoComplete="off"
              name="phoneNumber"
              mask="(###) ###-##-##"
              maxLength={15}
              disabled={disabled}
              placeholder="Укажите номер телефона"
              style={{ width: 224 }}
            />
          )}
        </Form.Item>
      </div>
      <div className="offer-card__item">
        <span className="label">E-mail для уведомлений:</span>
        <Form.Item>
          {getFieldDecorator("email")(
            <Input style={{ width: 368 }} disabled={disabled} />
          )}
        </Form.Item>
      </div>
      <div
        className="offer-card__item "
        style={{ display: "flex", alignItems: "center" }}
      >
        <span className="label" style={{ lineHeight: "16px" }}>
          Сайт, на котором размещены правила оказания транспортных услуг:
        </span>
        <Form.Item>
          {getFieldDecorator("site")
          (
            <Input
              style={{ width: 368 }}
              disabled={disabled}
              placeholder={disabled ? "Сайт не указан" : "Укажите сайт"}
            />
          )}
        </Form.Item>
      </div>
    </>
  );
};
